/* eslint-disable radix */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import Loader from 'components/common/Loader';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import { vendorCouponsColumns } from 'pages/OfferCoupons/constants';
import { TRADER_COUPON_BY_ID_QUERY } from 'pages/OfferCoupons/CouponGraphQL';

const VendorList = ({ couponId }) => {
  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
    couponId: parseInt(couponId),
  });

  const { data, loading, error } = useQuery(TRADER_COUPON_BY_ID_QUERY, {
    variables: {
      ...filters,
    },
    fetchPolicy: 'network-only',
  });

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo:
        data?.traderCouponListByCouponId?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };

  const onSortChange = (sort) => {
    setFilters({
      ...filters,

      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.traderCouponListByCouponId?.couponTraders)
    return <NoDataFound message="Vendors not available" />;

  return (
    <FSBTable
      data={(data && data?.traderCouponListByCouponId?.couponTraders) || []}
      totalCount={data?.traderCouponListByCouponId?.totalCount}
      totalPages={data?.traderCouponListByCouponId?.totalPages}
      columns={vendorCouponsColumns}
      currentPageNo={filters.pageNo}
      pageSize={filters.pageSize}
      keyField="id"
      showSearch={false}
      showFilters
      showDelete={false}
      showPagination
      remote
      striped={false}
      hover={false}
      bordered={false}
      wrapperClass="table-responsive word-break"
      handlePageChange={handlePageChange}
      onSortChange={onSortChange}
      sorting={sortBy}
      searchPlaceholder="Search Vendors"
    />
  );
};
export default VendorList;
